import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';
import { HeatingMediumEnum } from 'src/types/ViewModel/Vessel/HeatingMediumEnum';

export const incompatibleHeatingMediumSoftRule: StowageRuleBM = {
    id: StowageRuleId.IncompatibleHeatingMediumSoftRule,
    name: 'A cargo for which the IBC chapter 15.16.2 applies should not be stowed in a tank with water or steam heating.',
    lastUpdatedUtc: '2024-08-25T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                operator: BooleanOperator.AND,
                children: [
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Cargo property product.category.isAnnexIIChapter17',
                                    fieldPath: 'cargo.product.category.isAnnexIIChapter17',
                                    type: 'boolean',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'boolean',
                                    referenceValue: 'true',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Equals,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category specific and operational requirements',
                                    fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'IBC chapter 15.16.2',
                                    type: 'string',
                                    referenceValue: 'IBC-15.16.2',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Contains,
                        },
                    },
                    {
                        operator: BooleanOperator.OR,
                        children: [
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank heating medium',
                                            fieldPath: 'tank.heatingMedium',
                                            type: 'string',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'string',
                                            referenceValue: HeatingMediumEnum.Water.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                            {
                                leaf: {
                                    properties: [
                                        {
                                            name: 'Tank heating medium',
                                            fieldPath: 'tank.heatingMedium',
                                            type: 'string',
                                            location: StowageRulePropertyLocation.Tank,
                                        },
                                        {
                                            name: 'Reference value',
                                            type: 'string',
                                            referenceValue: HeatingMediumEnum.Steam.toString(),
                                            location: StowageRulePropertyLocation.NA,
                                        },
                                    ],
                                    scope: StowageRuleTestScope.Tank,
                                    operator: StowageRulePropertyOperator.Equals,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Incompatible heating medium',
    },
};
